var _rect, _path, _polygon, _path2, _path3, _polygon2, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHyundai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 128.6",
    width: 1000,
    height: 128.6,
    xmlSpace: "preserve",
    className: "svg icon--default",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 978.2,
    y: 14.2,
    className: "st0",
    width: 21.8,
    height: 100.3,
    fill: "#002c5f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M863.1,35.8v78.6h21.8V85.6h49.7v28.8h21.8V14.2h-71.5C868.7,14.2,863.1,22,863.1,35.8z M893.7,32.6h40.9V66 h-49.7v-23C884.9,34.7,886.8,33,893.7,32.6z",
    fill: "#002c5f"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "377,53.7 328.3,53.7 328.3,14.2 306.5,14.2 306.5,114.4 328.3,114.4 328.3,73.5 377,73.5 377,114.4 398.8,114.4 398.8,14.2 377,14.2 ",
    fill: "#002c5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M709.5,14.2h-70.2l0,100.3h21.8V32.6h38.2c6.8,0,7.8,1.8,7.8,10.5v71.4H729V35.8 C729.2,15.6,719.5,14.2,709.5,14.2z",
    fill: "#002c5f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.5,14.2h-21.8v71.6c0,8.6-1,9.6-7.8,9.6h-38.2l0-81.2h-21.8v100.3h70.2c14,0,19.7-4,19.4-24.2V14.2z",
    fill: "#002c5f"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "463.5,55.2 436.2,14.2 409.7,14.2 452.6,78.3 452.6,114.4 474.4,114.4 474.4,78.3 517,14.2 490.5,14.2 ",
    fill: "#002c5f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M819.5,14.2h-68.7v100.3h68.7c12.1,0,21.8-7.1,21.8-24.3V35.8C841.3,26,838.1,14.2,819.5,14.2z M819.2,85.6 c0,4.1-0.7,9.2-9.2,9.6l-37.5,0V32.6H810c5.9,0,9.2,3.8,9.2,9.3V85.6z",
    fill: "#002c5f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.1,20.1c-6.3-3.4-13-6.1-19.7-8.6C168.2,1.2,132.8-2.4,99.2,1.6c-31,4.2-61.1,11.6-84.7,33.1 C3.2,45.2-3.6,61,2,76.1c7.2,18.4,26.4,30.7,43.6,37.8c50.7,20.5,119.7,19.8,168.8-3.7c16.8-8.5,35.6-22.6,38-42.8 C254.3,45.7,235,29.4,218.1,20.1z M104.5,28.7c4.2-8.2,11.8-17.9,22.2-18.1c22.4-0.2,43.6,3.2,63.7,8.8c1.2,0.6,2.6,0.9,3.4,2.1 c0.6,1.4-0.6,2.2-1.4,3.1c-16.6,13-35.6,20.2-54.9,26.5c-9.9,2.4-19.8,6.7-30.8,4.3c-2.6-0.6-4.9-2.3-6.3-4.8 C97.6,43.1,101.3,35.3,104.5,28.7z M37.5,96.2c-2.6,2.4-5-0.8-7.4-1.8C18.4,86.6,7.8,74.2,10.9,59.5C15.7,40.2,35.5,30,52,23 c9.8-3.7,19.9-6.6,30.7-8.3c1.1,0,2.6-0.2,3.1,0.9l-0.3,1.2C64.4,40.7,50.6,68.5,37.5,96.2z M145,105.4 c-4.8,7.4-12.7,13.9-22.3,12.9c-21.4-0.3-42.3-3.6-61.7-9.5c-0.9-0.2-1.8-0.8-2.2-1.6c-0.4-1.1,0.2-2.2,1-2.9 c17.7-14.3,38.8-21,59.6-28c7.8-2.2,16-4.6,24.7-3.5c3.6,0.5,7.2,3,8.5,6.3C154.5,89.1,149.3,97.4,145,105.4z M241.4,69.5 c-5,19.9-26.6,30.4-43.8,37.2c-9.4,3.1-18.8,6.3-29.1,7.3c-0.6-0.1-1.7,0.1-1.8-0.9l0.2-1.1c14.6-16.4,25.6-34.8,35.3-53.5 c4.5-8.4,8.7-17.1,12.5-25.5c0.6-0.6,1.1-1,1.8-1.2c3.6,0.3,6.2,3.1,9,5C235.5,44.9,244.5,56,241.4,69.5z",
    fill: "#002c5f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyundai);
export default __webpack_public_path__ + "static/media/hyundai.f5adaf57dae8609d1c17b4ce207107b8.svg";
export { ForwardRef as ReactComponent };